<form class="register-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <h1 class="headline-large">Register</h1>
  <mat-form-field class="register-field">
    <mat-label>Email</mat-label>
    <input matInput type="text" aria-labelledby="Email" formControlName="email" />
  </mat-form-field>
  <mat-form-field class="register-field shift-right">
    <mat-label>First Name</mat-label>
    <input matInput type="text" aria-labelledby="First Name" formControlName="firstName" />
  </mat-form-field>
  <mat-form-field class="register-field shift-right">
    <mat-label>Last Name</mat-label>
    <input matInput type="text" aria-labelledby="Last Name" formControlName="lastName" />
  </mat-form-field>
  <mat-form-field class="register-field shift-right">
    <mat-label>Password</mat-label>
    <input type="password" matInput aria-labelledby="Password" formControlName="password" />
  </mat-form-field>
  <mat-form-field class="register-field shift-right">
    <mat-label>Confirm Password</mat-label>
    <input type="password" matInput aria-labelledby="Confirm your password" formControlName="confirmedPassword" />
  </mat-form-field>
  <mat-error *ngIf="registerForm.touched && registerForm.invalid">{{ getErrorMessage() }}</mat-error>
  <mat-error *ngIf="registerError">{{ registerError }}</mat-error>

  <div class="display-flex justify-content-end align-items-center">
    <a class="forget-password mr-3" routerLink="/auth/login" mat-button tabindex="0" role="link" aria-labelledby="Log In"> Log In </a>
    <button mat-flat-button aria-label="Complete" #submitButton class="buttons" type="submit" color="primary" tabindex="0">Complete</button>
  </div>
</form>
